import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

import { getEnv } from "@bfc-software/bfc-web-ui/environment";

/**
 * BFC's own operational tooling - task plans, the plan simulator, webhooks, and
 * the FTP job and config screens. Presented to users as "Engine Room".
 *
 * This is one app among several under an organisation, and it owns its own URL
 * segment: /orgs/{org}/internal/... Warehouse scope lives *inside* here rather
 * than in the app shell, because it belongs to the tools that need one. The
 * tile screen has none.
 *
 * None of this appears in the customer portal design, and it is not deferred
 * work that will - it stays internal.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/internal",
)({
  beforeLoad: () => {
    if (!getEnv().internalToolsEnabled) {
      // Nothing here should acknowledge it exists to someone without access,
      // so this is a 404 rather than a redirect or a "permission denied" page.
      throw notFound();
    }
  },
  component: Outlet,
});
